import { CheckCircle2, XCircle, AlertTriangle, Clock, Zap, Brain, Database, Users, Terminal } from "lucide-react";

export const getStatusIcon = (status) => {
  switch (status) {
    case "SUCCESS": case "pass": return <CheckCircle2 className="w-4 h-4 text-emerald-500" />;
    case "FAILURE": case "fail": return <XCircle className="w-4 h-4 text-red-500" />;
    case "ERROR": case "warning": return <AlertTriangle className="w-4 h-4 text-amber-500" />;
    default: return <Clock className="w-4 h-4 text-slate-400" />;
  }
};

export const getOperationIcon = (type) => {
  switch (type) {
    case "API_CALL": return <Zap className="w-4 h-4" />;
    case "AI_ANALYSIS": return <Brain className="w-4 h-4" />;
    case "DB_OPERATION": return <Database className="w-4 h-4" />;
    case "AUTH": return <Users className="w-4 h-4" />;
    default: return <Terminal className="w-4 h-4" />;
  }
};
